import React, { useState, useEffect } from "react";
import { Biscuit, Notification, getAllUrlParams } from "../../../utils";
import Rbac from "../../../utils/Rbac";
import { getApiHost } from "../../../Sync";

import {
  productsSelectors,
  productsActions,
  alertsActions,
  resourcesActions,
  priceTariffsActions,
  userActions,
  useSelector,
} from "inbooma-api";
import t from "../../helpers/t";
import useAddProductForm from "./CustomHooks/UseProductAddForm.js";

import ProductSidebar from "./components/ProductSidebar";
import ItemView from "./components/ItemView";
import SortNav from "../../components/SortNav";
import { render } from "react-dom";
import ContingentsControllerAccessBarMap from "../../../controllers/ContingentsControllerAccessBarMap";
import InboomaSubmenu from "../../components/InboomaSubmenu";
import Product from "./components/Product";
import { moment } from "../../../../vendor";
import { getItem, setItem } from "../../../utils/Helper";
import { createSubmenuItems } from "../../../utils/Helper";
import { useSortable } from "@dnd-kit/react/sortable";
import { DndContext } from "@dnd-kit/core";
import { SortableContext } from "@dnd-kit/sortable";
import SortProvider from "../../components/SortBehavior/SortProvider";

export const rbac = new Rbac({
  _rbac: {
    admin: {
      write: true,
      editProduct: true,
    },
    manager: {
      write: false,
      editProduct: false,
    },
    "booking-manager": {
      write: false,
      editProduct: false,
    },
    "manager-location": {
      write: false,
      editProduct: false,
    },
    user: {
      write: false,
      editProduct: false,
    },
    "garage-staff": {
      write: false,
      editProduct: false,
    },
    mediator: {
      write: false,
      editProduct: false,
    },
    guide: {
      write: false,
      editProduct: false,
    },
  },
});

let selectedEntityCopy = null;
let _id = 0; // For internal - "temporary" - document items

export const ProductsPage = (props) => {
  const language = Biscuit.get("user.lang").replace("-", "_");
  let y = 4;
  const currentUrl = new URL(window.location.href);
  const searchParams = currentUrl.searchParams;
  const allUrlParams = getAllUrlParams(window.location.href);
  const [contingent, setContingent] = useState(getItem("contingent", true));
  const [contingentTemp, setContingentTemp] = useState(null);
  const [exit, setExit] = useState(false);
  const [activeProduct, setActiveProduct] = useState(null);
  const [previousProduct, setPreviousProduct] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [toggleItemView, setToggleItemView] = useState(false);
  const [sortBarBuilded, setSortBarBuilded] = useState(false);
  const [productsForFind, setProductsForFind] = useState(null);
  const [products, setProducts] = useState([]);
  const paginationLimit = 40;
  const [pagination, setPagination] = useState({
    has_next_page: false,
    current_page: 1,
  });
  const [addProductEditMode, setAddProductEditMode] = useState(false);
  const [contingentsForSelect, setContingentsForSelect] = useState(null);
  const [settedFilter, setSettedFilter] = useState({ sort: "sort_order" });
  /* const [initialized, setInitialized] = useState(false);
    const [products, setProducts] = useState(props.products);
    const [productsPending, setProductsPending] = useState(false);
    const _products = useSelector(state => state.products_data.products);*/
  // @todo:
  //const [sortKey, setSortKey] = useState('name');
  //const [sortDirection, setSortDirection] = useState('desc');
  const productsList = () => this.setState({ products: props.products });
  const dropRef = React.createRef();
  const _queryState = {
    timeStamp: 0,
    value: "",
  };

  useEffect(() => {
    setProducts(props.products);
  }, [props.products]);
  function Sortable({ id, index, product }) {
    const { ref } = useSortable({ id, index });

    return (
      <>
        <div
          ref={ref}
          className="inb-c-item inb-c-item--product medium-3 small-12 column item"
          key={id}
        >
          <Product
            product={product}
            forceReInit={forceReInit}
            count={count}
            dispatch={props.dispatch}
            sort={index}
          />
        </div>
      </>
    );
  }

  const clickOpenProduct = (product_id) => {
    const id = product_id;

    const callback = (response) => {
      if (response.success) {
        setActiveProduct(Number(id));
        const activeProductEntity = productsSelectors.getProductById(products, Number(id));

        setProductsForFind(response.data.linkable_products);
        let contingentValues = [];
        props.contingents.forEach(function (value, key) {
          if (typeof response.data.contingents !== "undefined") {
            response.data.contingents.forEach(function (subValue, subKey) {
              if (subValue.id === value.id) {
                let _helper = new Array();
                _helper["value"] = subValue.id;
                _helper["label"] = value.name;
                contingentValues.push(_helper);
              }
            });
          }
        });
        let productValues = [];
        if (typeof response.data.products !== "undefined") {
          response.data._requiredProducts = [];
          response.data._products = [];
          response.data.products.forEach(function (subValue, subKey) {
            if (subValue.required > 0) {
              response.data._requiredProducts.push(subValue);
            } else {
              response.data._products.push(subValue);
            }
          });
        }
        setContingentsForSelect(contingentValues);
        response.data.contingentsForSelect = contingentValues;
        setSelectedProduct(response.data);
        setToggleItemView(true);
        // setPreviousProduct(activeProductEntity.parent_id);
      } else {
        props.dispatch(
          alertsActions.addAlert({
            message: t("error_product_access_forbidden"),
            icon: "fi fi-x",
          }),
        );
      }
    };
    const callbackIntern = (resp) => {};

    if (id !== null) {
      props.dispatch(
        productsActions.getProduct({
          id: id,
          callback,
          token: Biscuit.get("token"),
        }),
      );
      setActiveProduct(Number(id));
      const activeProductEntity = productsSelectors.getProductById(products, Number(id));
      setPreviousProduct(activeProductEntity.parent_id);
    } else {
      setActiveProduct(null);
      setPreviousProduct(null);
    }
    setAddProductEditMode(false);
  };

  const onAddProductSubmit = (name) => {
    if (name !== "" && name !== null) {
      props.dispatch(
        productsActions.addProduct({
          body: {
            name,
            client_id: Number(Biscuit.get("user.client_id")),
          },
          token: Biscuit.get("token"),
        }),
      );

      props.dispatch(
        alertsActions.addAlert({
          message: t("added_${a}", { a: t("product") }),
          icon: "fi fi-product-add",
        }),
      );
    }

    setAddProductEditMode(false);
  };

  const addProduct = () => {
    alert(`new Task added: Name: ${inputsForProducts.newProduct}`);
  };

  const onAddNewProduct = () => {
    setSelectedProduct(null);
    //  setToggleItemView(true);
  };

  const onCloseNewProduct = () => {
    //setToggleItemView(false);
    forceReInit();
  };

  const onExit = (e, cont = null) => {
    const currentUrl = new URL(window.location.href);
    if (cont !== null) {
      setItem("contingent", cont, true);
      window.location.replace("/contingents/add" + currentUrl.search);
    } else {
      // used close button without creating product
      if (contingent !== null || getItem("contingent", true) !== null) {
        window.location.replace("/contingents/add" + currentUrl.search);
      } else {
        // setToggleItemView(false);
        // forceReInit();
        window.location.replace("/products");
      }
    }
  };

  const forceReInit = () => {
    let filter = settedFilter;
    if (filter === null) {
      filter = {};
    }
    if (typeof filter.sort === "undefined") {
      filter.sort = "sort_order";
    }
    filter.limit = 1000;
    let language = Biscuit.get("user.lang").replace("_", "-");
    setTimeout(() => {
      props.dispatch(
        productsActions.getProducts({
          token: Biscuit.get("token"),
          filter: filter,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
    }, 1000);
  };

  const { inputsForProducts, handleInputChange, handleSubmit } = useAddProductForm(addProduct);

  const onEditProduct = (productId) => {
    clickOpenProduct(productId);
  };

  const onFilterChanged = (filter) => {
    if (typeof filter.parent_id !== "undefined") {
      setSettedFilter({ ...filter, parent_id: filter.parent_id });
    }
    if (typeof filter.sort === "undefined") {
      filter.sort = "sort_order";
    }
    filter.limit = paginationLimit;
    filter.page = pagination.current_page;
    let language = Biscuit.get("user.lang").replace("_", "-");
    props.dispatch(
      productsActions.getProducts({
        token: Biscuit.get("token"),
        filter: filter,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
  };

  /*  useEffect(() => {
        if(!initialized && !productsPending){
            props.dispatch(productsActions.getProducts({
                token: Biscuit.get('token'),
                filter: settedFilter,
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            setProductsPending(true);
            setInitialized(true);
        }
    }, []);*/

  /*useEffect(() => {
        if(_products.success === "" || !productsPending){
            return;
        }
        if(_products.success === true) {
            setProducts(_products.data);
            setPagination(_products.pagination);
        }
        setProductsPending(false);
    }, [_products]);*/

  useEffect(() => {
    if (
      selectedProduct === null ||
      (selectedEntityCopy !== null && selectedEntityCopy.id === selectedProduct.id)
    ) {
      // Problem: As of now, selectedEntity is not an ID (like activeProduct), but an object
      // -> react would not notice update of that entity when detailView is already open
      // Solution: Call setSelectedEntity in callback below to update DetailView
      // @todo Make selectedEntity numeric
      return;
    }

    // = setSelectedEntity callback
    if (selectedProduct !== null) {
      selectedEntityCopy = { ...selectedProduct };

      /* props.dispatch(productActions.getContingents({
                id: selectedProduct.id,
                token: Biscuit.get('token'),
                callback: (response) => {
                    if (response.success) {
                        setSelectedProduct(response.data);
                        setTimeout(() => { selectedEntityCopy = null }, 1000);
                    }
                }
            }));*/
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProduct]);

  const showNotification = (msgType, itemId) => {
    // little delay necessary to make notifications visible (render of background must be done before)
    setTimeout(() => {
      if (msgType === "success") {
        new Notification({
          message: t("saved_${a}", { a: t("product") }, "capital") + " #" + itemId,
          duration: 5000,
          type: "success",
          closeable: true,
          icon: "fi fi-check",
        });
      } else if (msgType === "warning") {
        new Notification({
          message: t("request_error", null, "capital"),
          duration: 5000,
          type: "warning",
          closeable: true,
          icon: "fi fi-x",
        });
      }
    }, 200);
  };

  const submenuItems = createSubmenuItems("products");
  let tabs = [
    {
      name: t("name", null, "capital"),
      mediumWidth: 2,
      smallWidth: 3,
      title: t("name", null, "capital"),
      canSort: false,
    },
    {
      name: t("description", null, "capital"),
      mediumWidth: 6,
      smallWidth: 3,
      title: t("description", null, "capital"),
      canSort: false,
    },
    {
      name: t("product type", null, "capital"),
      mediumWidth: 2,
      smallWidth: 4,
      title: t("product type", null, "capital"),
      canSort: false,
    },
  ];

  const searchBarHandler = (ev) => {
    let query;
    if (typeof ev.target !== "undefined") {
      query = ev.target.value.toLowerCase();
    } else {
      query = "";
    }
    const minLength = 3;
    let filter = settedFilter;
    let language = Biscuit.get("user.lang").replace("_", "-");
    if (query.length >= minLength) {
      // work user search only for values bigger or equal to the minimum length

      setTimeout(function () {
        let diff = Number(moment().format("x")) - _queryState.timeStamp;

        if (diff > 700 && _queryState.value == query) {
          // no changes after the last 700 ms -> user finished input -> start request
          // -> this avoids additional requests during typing
          props.dispatch(
            productsActions.getProducts({
              token: Biscuit.get("token"),
              parameters: {
                headers: {
                  "Accept-Language": language,
                  "Content-Language": language,
                },
              },
              filter: {
                ...filter,
                q: query,
              },
            }),
          );
          setSettedFilter({
            ...filter,
            q: query,
          });
        }
      }, 800);
    } else if (filter.q !== undefined) {
      // reset filter when query was active
      let clone = { ...filter };
      delete clone.q;
      setSettedFilter(clone);

      props.dispatch(
        productsActions.getProducts({
          token: Biscuit.get("token"),
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
          filter: {
            ...clone,
          },
        }),
      );
    }

    _queryState.timeStamp = Number(moment().format("x"));
    _queryState.value = query;
  };
  let count = 0;
  /*  const loadNextPage = (page) => {

        // if (!pagination.has_next_page) return;

        setProductsPending(true);

        if(page > 1){
            searchParams.set('page', page);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else{
            searchParams.delete('page');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        props.dispatch(productsActions.getProducts({
            token: Biscuit.get('token'),
            filter: {
                ...settedFilter,
                page: page,
                limit: paginationLimit
            },
            parameters: {
                headers: {
                    "Accept-Language": language
                }
            }
        }));
    };*/
  const sortFunction = (items) => {
    const clone = [];
    Object.assign(clone, products);
    items.map((item, index) => {
      let obj = clone.find((obj) => {
        return obj.id === item.id;
      });
      if (obj.sort_order !== index + 1) {
        obj.sort_order = index + 1;
        const payload = {
          token: Biscuit.get("token"),
          id: obj.id,
          body: { sort_order: obj.sort_order },
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        };
        console.log(payload);
        props.dispatch(productsActions.patchProduct(payload));
        let ind = clone.findIndex((obj) => {
          return obj.id === item.id;
        });
        clone[ind] = obj;
      }
    });
    setProducts(clone);
  };

  return (
    <>
      <ProductSidebar
        Products={products}
        //contingents={props.contingents}
        productsFetchSuccess={props.productsFetchSuccess}
        activeProduct={activeProduct}
        dispatch={props.dispatch}
        setAddProductEditMode={setAddProductEditMode}
        setActiveProduct={setActiveProduct}
        addNewProduct={onAddNewProduct}
        setSelectedFilter={onFilterChanged}
      />

      <div id="inb-c-main" className="columns">
        {props.createAccessBar && (
          <InboomaSubmenu
            tabs={submenuItems}
            searchbar={true}
            extraClasses={"sticky-top"}
            searchbarPlaceholder={t("product_name")}
            searchbarHandler={searchBarHandler}
            smallOnlyTitle={t("products", null, "capital")}
            //pagination={pagination}
            //itemsCountPerPage={paginationLimit}
            //pageRangeDisplayed={5}
            //onChange={loadNextPage}
          />
        )}
        {/* <SortNav
                    tabs={tabs}
                    />*/}

        <div className="off-canvas-wrapper">
          <div id="inb-c-main-products" className="row" data-off-canvas-content="">
            {!props.productsFetchSuccess && products.length < 0 ? (
              <>
                <div className="inb-c-loader">
                  <div className="inb-c-loader--item">
                    <div className="inb-c-loader--bg row">
                      <div className="loader-mask r-1 medium-offset-1 medium-1 column"></div>
                      <div className="loader-mask r-1 medium-offset-4 medium-1 column"></div>
                      <div className="loader-mask r-1 medium-offset-7 medium-1 column"></div>
                      <div className="loader-mask r-1 medium-offset-10 medium-1"></div>
                      <div className="loader-mask vert-ph-1"></div>
                      <div className="loader-mask r-2 medium-offset-1 medium-1 column"></div>
                      <div className="loader-mask r-2 medium-offset-4 medium-8 column"></div>
                      <div className="loader-mask r-2 medium-offset-7 medium-1 column"></div>
                      <div className="loader-mask r-2 medium-offset-10 medium-1"></div>
                      <div className="loader-mask vert-ph-2"></div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                {products.length > 0 && (
                  <>
                    <SortProvider
                      elements={products.filter((obj) => {
                        return (
                          obj.parentId !== null &&
                          obj.parent_id !== 0 &&
                          obj.client_id !== 0 &&
                          obj.client_id !== null &&
                          obj.deleted === null &&
                          ((settedFilter.parent_id !== "undefined" &&
                            obj.parent_id === settedFilter.parent_id) ||
                            settedFilter.parent_id === null ||
                            settedFilter.q !== "undefined")
                        );
                      })}
                      sortKey="id"
                      sortFunction={sortFunction}
                      data={{
                        dispatch: props.dispatch,
                        forceReInit: forceReInit,
                        item: "",
                        model: "product",
                        count: count,
                      }}
                    />
                    {products
                      .filter((obj) => {
                        return (
                          obj.parentId !== null &&
                          obj.parent_id !== 0 &&
                          (obj.client_id === 0 || obj.client_id === null) &&
                          obj.deleted === null &&
                          ((settedFilter.parent_id !== "undefined" &&
                            obj.parent_id === settedFilter.parent_id) ||
                            settedFilter.parent_id === null ||
                            settedFilter.q !== "undefined")
                        );
                      })
                      .map((product, index) => (
                        <div
                          className="inb-c-item inb-c-item--product medium-3 small-12 column"
                          key={product.id}
                        >
                          <Product
                            product={product}
                            forceReInit={forceReInit}
                            count={count}
                            dispatch={props.dispatch}
                            index={index}
                          />
                        </div>
                      ))}
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {props.status.complete &&
        ((props.status.product === "finished" && props.status.product_id === props.product.id) ||
          (props.status.product === "add" && props.status.product_id === null)) && (
          <ItemView
            entity={props.status.product_id === null ? null : props.product}
            productsArray={products}
            selectedProduct={props.status.product_id === null ? null : props.product}
            contingents={props.contingents}
            shortProducts={productsForFind}
            onClose={onCloseNewProduct}
            contingent={contingent}
            setContingent={setContingentTemp}
            onExit={onExit}
            dispatch={props.dispatch}
            showNotification={showNotification}
          />
        )}
    </>
  );
};
